import { render } from "./TasksListing.vue?vue&type=template&id=2b16a4ec&scoped=true"
import script from "./TasksListing.vue?vue&type=script&lang=js"
export * from "./TasksListing.vue?vue&type=script&lang=js"

import "./TasksListing.vue?vue&type=style&index=0&id=2b16a4ec&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16a4ec"]])

export default __exports__